import * as Yup from "yup";
export const initialValues = (data) => {
  return {
    image: data?.image,
    images: data?.media?.map((image) => image.url),

    wrap_id: data?.wrap_variant?.wrap?.id,
    wrap_variant_id: data?.wrap_variant?.id,
    ribbon_color_id: data?.ribbon_color?.id,
    wrap_extra_ids: data?.wrap_extras?.map((option) => {
      return {
        label: option?.name,
        value: option?.id,
      };
    }),
    wrappable_type: data?.wrappable_type === "cart" ? 1 : 2,
    show_in_packaging: data?.show_in_packaging ?? false,
    is_active: data?.is_active ?? true,
    display_priority: data?.display_priority ?? "",
    ...data?.localized_data,
  };
};
export const structure = (wrappable_type, options, t) => [
  {
    width: "40%",

    list: [
      {
        name: `image`,
        kind: "upload",
        type: "image",
        label: `${t("wrappers_suggested_wraps.cover_image")}*`,
        placeholder: t("wrappers_suggested_wraps.cover_image"),
        text: t("wrappers_suggested_wraps.file_types"),
        width: "100%",
      },
    ],
  },
  {
    head: "",
    width: "100%",
    whiteSpace: "wrap",
    list: [
      {
        name: `images`,
        kind: "multiUpload",
        type: "image",
        label: t("wrappers_suggested_wraps.images"),
        placeholder: t("wrappers_suggested_wraps.images"),
        text: t("wrappers_suggested_wraps.file_types"),
        width: "100%",
        whiteSpace: "wrap",
      },
    ],
  },

  {
    head: "",
    width: "100%",
    list: [
      {
        name: `en.name`,
        kind: "input",
        type: "text",
        label: `${t("wrappers_suggested_wraps.name_en")}*`,
        width: "47%",
        placeholder: t("wrappers_suggested_wraps.name_en"),
      },
      {
        name: `ar.name`,
        kind: "input",
        type: "text",
        label: t("wrappers_suggested_wraps.name_ar"),
        width: "47%",
        placeholder: t("wrappers_suggested_wraps.name_ar"),
      },
      {
        name: `wrap_id`,
        kind: "select",
        type: "text",
        label: t("wrappers_suggested_wraps.wrap_type"),
        width: "47%",
        placeholder: t("wrappers_suggested_wraps.wrap_type"),
        // options: wrapType,
        ...options?.wraps,
      },
      {
        name: `wrap_variant_id`,
        kind: "select",
        type: "text",
        label: `${t("wrappers_suggested_wraps.wrap_variant")}*`,
        width: "47%",
        placeholder: t("wrappers_suggested_wraps.wrap_variant"),
        ...options?.wrapVarinats,
      },
      {
        name: `ribbon_color_id`,
        kind: "select",
        type: "text",
        label: `${t("wrappers_suggested_wraps.ribbon_color")}*`,
        width: "47%",
        placeholder: t("wrappers_suggested_wraps.ribbon_color"),
        ...options?.ribbonColors,
      },
      {
        name: `wrap_extra_ids`,
        kind: "multiSelect",
        type: "text",
        label: t("wrappers_suggested_wraps.wrap_extras"),
        width: "47%",
        placeholder: t("wrappers_suggested_wraps.wrap_extras"),
        // isMulti: true,
        ...options?.wrapExtra,
      },
      {
        name: `en.description`,
        kind: "input",
        type: "text",
        multiline: true,
        rows: 3,
        label: t("wrappers_suggested_wraps.theme_description_en"),
        width: "47%",
        placeholder: t("wrappers_suggested_wraps.write_theme_description_en"),
      },
      {
        name: `ar.description`,
        kind: "input",
        type: "text",
        multiline: true,
        rows: 3,
        label: t("wrappers_suggested_wraps.theme_description_ar"),
        width: "47%",
        placeholder: t("wrappers_suggested_wraps.write_theme_description_ar"),
      },
      {
        name: `wrappable_type`,
        kind: "select",
        type: "text",
        label: t("wrappers_suggested_wraps.option_wrap_type"),
        width: "47%",
        placeholder: t("wrappers_suggested_wraps.choose_type"),
        options: wrappable_type,
      },
      {
        name: `show_in_packaging`,
        kind: "checkbox",
        label: t("wrappers_suggested_wraps.show_in_packaging"),
        width: "fit-content",
      },
      {
        name: `is_active`,
        kind: "checkbox",
        label: t("wrappers_suggested_wraps.is_active"),
        width: "fit-content",
      },
      {
        name: `display_priority`,
        kind: "input",
        type: "number",
        label: t("wrappers_suggested_wraps.display_priority"),
        width: "47%",
      },
    ],
  },
];

export const validationSchema = () =>
  Yup.object({
    image: Yup.string().required("Required"),
    // images: Yup.array().required('Required'),
    // wrap_id: Yup.string().required('Required'),
    wrap_variant_id: Yup.string().required("Required"),
    // wrappable_type: Yup.string().required('Required'),
    // wrap_extra_ids: Yup.array().required('Required'),
    ribbon_color_id: Yup.string().required("Required"),

    en: Yup.object().shape({
      name: Yup.string().required("Required"),
      // description: Yup.string().required('Required'),
    }),
    // ar: Yup.object().shape({
    //     name: Yup.string().required('Required'),
    //     description: Yup.string().required('Required'),

    // }),
    show_in_packaging: Yup.boolean(),
    is_active: Yup.boolean(),
    display_priority: Yup.number().typeError("Must be a number").nullable(),
  });
